import type { CSSProperties } from "react";

import OrderSocketNotificationModal from "../../../components/OrderSocketNotificationModal";

type OrderNotificationModalStyle = CSSProperties & {
    "--order-notification-stack-x": string;
    "--order-notification-stack-y": string;
};

type OrderNotificationStackProps = {
    closeOrderNotificationModal: (orderKeyToClose: string) => void;
    getOrderCreatedAtMs: (orderDetails?: CashBoxOrderItemData | null) => number | null;
    getOrderTrackingKey: (orderDetails?: CashBoxOrderItemData | null) => string | null;
    openOrderNotificationModals: CashBoxOrderItemData[];
};

const OrderNotificationStack = ({
    closeOrderNotificationModal,
    getOrderCreatedAtMs,
    getOrderTrackingKey,
    openOrderNotificationModals,
}: OrderNotificationStackProps) => {
    return (
        <>
            {openOrderNotificationModals
                .slice()
                .sort((a, b) => {
                    const aCreatedAtMs = getOrderCreatedAtMs(a) ?? Number.MAX_SAFE_INTEGER;
                    const bCreatedAtMs = getOrderCreatedAtMs(b) ?? Number.MAX_SAFE_INTEGER;
                    return aCreatedAtMs - bCreatedAtMs;
                })
                .map((orderDetails, index, sortedModals) => {
                    const orderKey = getOrderTrackingKey(orderDetails) || `order-modal-${index}`;
                    const isFrontModal = index === 0;
                    const stackOffsetLevel = index;
                    const modalZIndex = 2000 + (sortedModals.length - index) * 10;
                    const modalStyle: OrderNotificationModalStyle = {
                        zIndex: modalZIndex,
                        "--order-notification-stack-x": `${stackOffsetLevel * 10}px`,
                        "--order-notification-stack-y": `${stackOffsetLevel * 10}px`,
                    };

                    return (
                        <OrderSocketNotificationModal
                            key={orderKey}
                            orderDetails={orderDetails}
                            onHide={() => closeOrderNotificationModal(orderKey)}
                            backdrop={isFrontModal ? "static" : false}
                            enforceFocus={isFrontModal}
                            modalStyle={modalStyle}
                        />
                    );
                })}
        </>
    );
};

export default OrderNotificationStack;
